module.exports = __webpack_public_path__ + "img/scene1.d6753fff.png";